import IMask from "imask";

document.addEventListener("DOMContentLoaded", () => {
  const phoneInputs = document.querySelectorAll('input[type="tel"]');
  phoneInputs.forEach((input) => {
    IMask(input, {
      mask: [{ mask: "(00) 0000-0000" }, { mask: "(00) 00000-0000" }],
    });
  });
});
